export function getWordsFromText(text: string): string[] {
  return text.split('.').join('. ').replace(/\s+/g, ' ').split(' ');
}
